import { render, staticRenderFns } from "./PolicyRule.vue?vue&type=template&id=1710b525"
import script from "./PolicyRule.vue?vue&type=script&lang=js"
export * from "./PolicyRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports